import { render, staticRenderFns } from "./MultilingualTextarea.vue?vue&type=template&id=10de7ddf&scoped=true&"
import script from "./MultilingualTextarea.vue?vue&type=script&lang=js&"
export * from "./MultilingualTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MultilingualTextarea.vue?vue&type=style&index=0&id=10de7ddf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de7ddf",
  null
  
)

export default component.exports